module.exports = __webpack_public_path__ + "img/Intro_2.4c738480.gif";